<template>
  <el-dialog
    :title="title"
    :visible="visible"
    width="500px"
    append-to-body
    @close="close"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="150px">
      <el-form-item v-if="isAmount" :label="title" prop="amount"
        ><el-input-number
          v-model="form.amount"
          :min="0"
          :precision="2"
          :controls="false"
        /><span class="unit">元</span></el-form-item
      >
      <template v-if="action === 'recovery'"
        ><el-form-item label="第三者追偿可行性"
          ><el-radio-group v-model="form.recovery_three"
            ><el-radio :label="false">否</el-radio
            ><el-radio :label="true">是</el-radio></el-radio-group
          ></el-form-item
        ><el-form-item label="下游追偿可行性"
          ><el-radio-group v-model="form.recovery_downstream"
            ><el-radio :label="false">否</el-radio
            ><el-radio :label="true">是</el-radio></el-radio-group
          ></el-form-item
        ></template
      >
      <el-form-item v-if="action === 'damage'" label="损伤情形" prop="damage"
        ><el-input
          v-model="form.damage"
          type="textarea"
          :rows="4"
          maxlength="512"
          show-word-limit
      /></el-form-item>
      <el-form-item v-if="action === 'third'" label="第三者责任" prop="third"
        ><el-radio-group v-model="form.third"
          ><el-radio :label="1">涉及三者</el-radio
          ><el-radio :label="2">非涉及三者</el-radio></el-radio-group
        ></el-form-item
      >
      <el-form-item
        v-if="action === 'circulation'"
        label="预估处理时间"
        prop="circulation"
        ><el-select v-model="form.circulation"
          ><el-option
            v-for="(label, value) in circulationMap"
            :key="value"
            :label="label"
            :value="Number(value)"/></el-select
      ></el-form-item>
      <el-form-item v-if="action === 'finish'" label="结案日期" prop="date"
        ><el-date-picker
          v-model="form.date"
          type="date"
          value-format="yyyy-MM-dd"
      /></el-form-item>
    </el-form>
    <span slot="footer"
      ><el-button @click="close">取消</el-button
      ><el-button type="primary" :loading="saving" @click="save"
        >确认</el-button
      ></span
    >
  </el-dialog>
</template>

<script>
import {
  updateCargoAmount,
  saveRecoveryFeasibility,
  saveEmployerDamage,
  finishClaim
} from "@/api/claims-management";
import {
  CIRCULATION_TIMES,
  RISK_KEYS,
  toCents,
  toTimestamp
} from "../constants";

export default {
  name: "ClaimActionDialog",
  props: {
    visible: Boolean,
    action: String,
    orderId: [String, Number],
    riskType: Number
  },
  data() {
    return {
      saving: false,
      circulationMap: CIRCULATION_TIMES,
      form: {},
      rules: {
        amount: [{ required: true, message: "请输入金额", trigger: "blur" }],
        damage: [
          { required: true, message: "请输入损伤情形", trigger: "blur" }
        ],
        third: [
          { required: true, message: "请选择第三者责任", trigger: "change" }
        ],
        circulation: [
          { required: true, message: "请选择预估处理时间", trigger: "change" }
        ],
        date: [{ required: true, message: "请选择结案日期", trigger: "change" }]
      }
    };
  },
  computed: {
    title() {
      return (
        {
          claim_amount: "索赔金额",
          register_amount: "立案金额",
          loss_amount: "定损金额",
          recovery: "追偿可行性",
          damage: "损伤情形",
          third: "第三者责任",
          circulation: "预估处理时间",
          finish: "结案"
        }[this.action] || "案件处理"
      );
    },
    isAmount() {
      return ["claim_amount", "register_amount", "loss_amount"].includes(
        this.action
      );
    }
  },
  watch: {
    visible(value) {
      if (value) {
        this.form = {
          amount: 0,
          recovery_three: false,
          recovery_downstream: false,
          damage: "",
          third: null,
          circulation: null,
          date: ""
        };
        this.$nextTick(
          () => this.$refs.form && this.$refs.form.clearValidate()
        );
      }
    }
  },
  methods: {
    save() {
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        this.saving = true;
        try {
          const id = Number(this.orderId);
          if (this.isAmount)
            await updateCargoAmount({
              id,
              [this.action]: toCents(this.form.amount)
            });
          if (this.action === "recovery")
            await saveRecoveryFeasibility({
              id,
              feasibility_of_recovery_three: this.form.recovery_three,
              feasibility_of_recovery_downstream: this.form.recovery_downstream
            });
          if (this.action === "damage")
            await saveEmployerDamage({
              id,
              damage_situation: this.form.damage
            });
          if (this.action === "third")
            await saveEmployerDamage({ id, is_three: Number(this.form.third) });
          if (this.action === "circulation")
            await saveEmployerDamage({
              id,
              case_circulation_time: Number(this.form.circulation)
            });
          if (this.action === "finish")
            await finishClaim(RISK_KEYS[this.riskType], {
              id,
              claimed_date: toTimestamp(this.form.date)
            });
          this.$message.success("保存成功");
          this.$emit("changed");
          this.close();
        } finally {
          this.saving = false;
        }
      });
    },
    close() {
      this.$emit("update:visible", false);
    }
  }
};
</script>

<style scoped>
.unit {
  margin-left: 8px;
  color: #909399;
}
</style>
